/**
 * Returns a list with stopwords for the Greek passive voice assessment.
 *
 * @type {Array} The list with stopwords.
 */
export default [
	"ένα",
	"έναν",
	"ένας",
	"αι",
	"ακομα",
	"ακομη",
	"ακριβως",
	"αληθεια",
	"αληθινα",
	"αλλα",
	"αλλαχου",
	"αλλες",
	"αλλη",
	"αλλην",
	"αλλης",
	"αλλιως",
	"αλλιωτικα",
	"αλλο",
	"αλλοι",
	"αλλοιως",
	"αλλοιωτικα",
	"αλλον",
	"αλλος",
	"αλλοτε",
	"αλλου",
	"αλλους",
	"αλλων",
	"αμα",
	"αμεσα",
	"αμεσως",
	"αν",
	"ανα",
	"αναμεσα",
	"αναμεταξυ",
	"ανευ",
	"αντι",
	"αντιπερα",
	"αντις",
	"ανω",
	"ανωτερω",
	"αξαφνα",
	"απ",
	"απεναντι",
	"απο",
	"αποψε",
	"από",
	"αρα",
	"αραγε",
	"αργα",
	"αργοτερο",
	"αριστερα",
	"αρκετα",
	"αρχικα",
	"ας",
	"αυριο",
	"αυτα",
	"αυτες",
	"αυτεσ",
	"αυτη",
	"αυτην",
	"αυτης",
	"αυτο",
	"αυτοι",
	"αυτον",
	"αυτος",
	"αυτοσ",
	"αυτου",
	"αυτους",
	"αυτουσ",
	"αυτων",
	"αφοτου",
	"αφου",
	"αἱ",
	"αἳ",
	"αἵ",
	"αὐτόσ",
	"αὐτὸς",
	"αὖ",
	"α∆ιακοπα",
	"βεβαια",
	"βεβαιοτατα",
	"γάρ",
	"γα",
	"γα^",
	"γε",
	"γι",
	"για",
	"γοῦν",
	"γρηγορα",
	"γυρω",
	"γὰρ",
	"δ'",
	"δέ",
	"δή",
	"δαί",
	"δαίσ",
	"δαὶ",
	"δαὶς",
	"δε",
	"δεν",
	"δι",
	"δι'",
	"διά",
	"δια",
	"διὰ",
	"δὲ",
	"δὴ",
	"δ’",
	"εαν",
	"εαυτο",
	"εαυτον",
	"εαυτου",
	"εαυτους",
	"εαυτων",
	"εγκαιρα",
	"εγκαιρως",
	"εγω",
	"ειθε",
	"ειμαι",
	"ειμαστε",
	"ειναι",
	"εις",
	"εισαι",
	"εισαστε",
	"ειστε",
	"ειτε",
	"ειχα",
	"ειχαμε",
	"ειχαν",
	"ειχατε",
	"ειχε",
	"ειχες",
	"ει∆εμη",
	"εκ",
	"εκαστα",
	"εκαστες",
	"εκαστη",
	"εκαστην",
	"εκαστης",
	"εκαστο",
	"εκαστοι",
	"εκαστον",
	"εκαστος",
	"εκαστου",
	"εκαστους",
	"εκαστων",
	"εκει",
	"εκεινα",
	"εκεινες",
	"εκεινεσ",
	"εκεινη",
	"εκεινην",
	"εκεινης",
	"εκεινο",
	"εκεινοι",
	"εκεινον",
	"εκεινος",
	"εκεινοσ",
	"εκεινου",
	"εκεινους",
	"εκεινουσ",
	"εκεινων",
	"εκτος",
	"εμας",
	"εμεις",
	"εμενα",
	"εμπρος",
	"εν",
	"ενα",
	"εναν",
	"ενας",
	"ενος",
	"εντελως",
	"εντος",
	"εντωμεταξυ",
	"ενω",
	"ενός",
	"εξ",
	"εξαφνα",
	"εξης",
	"εξισου",
	"εξω",
	"επ",
	"επί",
	"επανω",
	"επειτα",
	"επει∆η",
	"επι",
	"επισης",
	"επομενως",
	"εσας",
	"εσεις",
	"εσενα",
	"εστω",
	"εσυ",
	"ετερα",
	"ετεραι",
	"ετερας",
	"ετερες",
	"ετερη",
	"ετερης",
	"ετερο",
	"ετεροι",
	"ετερον",
	"ετερος",
	"ετερου",
	"ετερους",
	"ετερων",
	"ετουτα",
	"ετουτες",
	"ετουτη",
	"ετουτην",
	"ετουτης",
	"ετουτο",
	"ετουτοι",
	"ετουτον",
	"ετουτος",
	"ετουτου",
	"ετουτους",
	"ετουτων",
	"ετσι",
	"ευγε",
	"ευθυς",
	"ευτυχως",
	"εφεξης",
	"εχει",
	"εχεις",
	"εχετε",
	"εχθες",
	"εχομε",
	"εχουμε",
	"εχουν",
	"εχτες",
	"εχω",
	"εως",
	"εἰ",
	"εἰμί",
	"εἰμὶ",
	"εἰς",
	"εἰσ",
	"εἴ",
	"εἴμι",
	"εἴτε",
	"ε∆ω",
	"η",
	"ημασταν",
	"ημαστε",
	"ημουν",
	"ησασταν",
	"ησαστε",
	"ησουν",
	"ηταν",
	"ητανε",
	"ητοι",
	"ηττον",
	"η∆η",
	"θα",
	"ι",
	"ιι",
	"ιιι",
	"ισαμε",
	"ισια",
	"ισως",
	"ισωσ",
	"ι∆ια",
	"ι∆ιαν",
	"ι∆ιας",
	"ι∆ιες",
	"ι∆ιο",
	"ι∆ιοι",
	"ι∆ιον",
	"ι∆ιος",
	"ι∆ιου",
	"ι∆ιους",
	"ι∆ιων",
	"ι∆ιως",
	"κ",
	"καί",
	"καίτοι",
	"καθ",
	"καθε",
	"καθεμια",
	"καθεμιας",
	"καθενα",
	"καθενας",
	"καθενος",
	"καθετι",
	"καθολου",
	"καθως",
	"και",
	"κακα",
	"κακως",
	"καλα",
	"καλως",
	"καμια",
	"καμιαν",
	"καμιας",
	"καμποσα",
	"καμποσες",
	"καμποση",
	"καμποσην",
	"καμποσης",
	"καμποσο",
	"καμποσοι",
	"καμποσον",
	"καμποσος",
	"καμποσου",
	"καμποσους",
	"καμποσων",
	"κανεις",
	"κανεν",
	"κανενα",
	"κανεναν",
	"κανενας",
	"κανενος",
	"καποια",
	"καποιαν",
	"καποιας",
	"καποιες",
	"καποιο",
	"καποιοι",
	"καποιον",
	"καποιος",
	"καποιου",
	"καποιους",
	"καποιων",
	"καποτε",
	"καπου",
	"καπως",
	"κατ",
	"κατά",
	"κατα",
	"κατι",
	"κατιτι",
	"κατοπιν",
	"κατω",
	"κατὰ",
	"καὶ",
	"κι",
	"κιολας",
	"κλπ",
	"κοντα",
	"κτλ",
	"κυριως",
	"κἀν",
	"κἂν",
	"λιγακι",
	"λιγο",
	"λιγωτερο",
	"λογω",
	"λοιπα",
	"λοιπον",
	"μέν",
	"μέσα",
	"μή",
	"μήτε",
	"μία",
	"μα",
	"μαζι",
	"μακαρι",
	"μακρυα",
	"μαλιστα",
	"μαλλον",
	"μας",
	"με",
	"μεθ",
	"μεθαυριο",
	"μειον",
	"μελει",
	"μελλεται",
	"μεμιας",
	"μεν",
	"μερικα",
	"μερικες",
	"μερικοι",
	"μερικους",
	"μερικων",
	"μεσα",
	"μετ",
	"μετά",
	"μετα",
	"μεταξυ",
	"μετὰ",
	"μεχρι",
	"μη",
	"μην",
	"μηπως",
	"μητε",
	"μη∆ε",
	"μιά",
	"μια",
	"μιαν",
	"μιας",
	"μολις",
	"μολονοτι",
	"μοναχα",
	"μονες",
	"μονη",
	"μονην",
	"μονης",
	"μονο",
	"μονοι",
	"μονομιας",
	"μονος",
	"μονου",
	"μονους",
	"μονων",
	"μου",
	"μπορει",
	"μπορουν",
	"μπραβο",
	"μπρος",
	"μἐν",
	"μὲν",
	"μὴ",
	"μὴν",
	"να",
	"ναι",
	"νωρις",
	"ξανα",
	"ξαφνικα",
	"ο",
	"οι",
	"ολα",
	"ολες",
	"ολη",
	"ολην",
	"ολης",
	"ολο",
	"ολογυρα",
	"ολοι",
	"ολον",
	"ολονεν",
	"ολος",
	"ολοτελα",
	"ολου",
	"ολους",
	"ολων",
	"ολως",
	"ολως∆ιολου",
	"ομως",
	"ομωσ",
	"οποια",
	"οποιαν",
	"οποιαν∆ηποτε",
	"οποιας",
	"οποιας∆ηποτε",
	"οποια∆ηποτε",
	"οποιες",
	"οποιες∆ηποτε",
	"οποιο",
	"οποιοι",
	"οποιον",
	"οποιον∆ηποτε",
	"οποιος",
	"οποιος∆ηποτε",
	"οποιου",
	"οποιους",
	"οποιους∆ηποτε",
	"οποιου∆ηποτε",
	"οποιο∆ηποτε",
	"οποιων",
	"οποιων∆ηποτε",
	"οποι∆ηποτε",
	"οποτε",
	"οποτε∆ηποτε",
	"οπου",
	"οπου∆ηποτε",
	"οπως",
	"οπωσ",
	"ορισμενα",
	"ορισμενες",
	"ορισμενων",
	"ορισμενως",
	"οσα",
	"οσα∆ηποτε",
	"οσες",
	"οσες∆ηποτε",
	"οση",
	"οσην",
	"οσην∆ηποτε",
	"οσης",
	"οσης∆ηποτε",
	"οση∆ηποτε",
	"οσο",
	"οσοι",
	"οσοι∆ηποτε",
	"οσον",
	"οσον∆ηποτε",
	"οσος",
	"οσος∆ηποτε",
	"οσου",
	"οσους",
	"οσους∆ηποτε",
	"οσου∆ηποτε",
	"οσο∆ηποτε",
	"οσων",
	"οσων∆ηποτε",
	"οταν",
	"οτι",
	"οτι∆ηποτε",
	"οτου",
	"ου",
	"ουτε",
	"ου∆ε",
	"οχι",
	"οἱ",
	"οἳ",
	"οἷς",
	"οὐ",
	"οὐδ",
	"οὐδέ",
	"οὐδείσ",
	"οὐδεὶς",
	"οὐδὲ",
	"οὐδὲν",
	"οὐκ",
	"οὐχ",
	"οὐχὶ",
	"οὓς",
	"οὔτε",
	"οὕτω",
	"οὕτως",
	"οὕτωσ",
	"οὖν",
	"οὗ",
	"οὗτος",
	"οὗτοσ",
	"παλι",
	"παντοτε",
	"παντου",
	"παντως",
	"παρ",
	"παρά",
	"παρα",
	"παρὰ",
	"περί",
	"περα",
	"περι",
	"περιπου",
	"περισσοτερο",
	"περσι",
	"περυσι",
	"περὶ",
	"πια",
	"πιθανον",
	"πιο",
	"πισω",
	"πλαι",
	"πλεον",
	"πλην",
	"ποια",
	"ποιαν",
	"ποιας",
	"ποιες",
	"ποιεσ",
	"ποιο",
	"ποιοι",
	"ποιον",
	"ποιος",
	"ποιοσ",
	"ποιου",
	"ποιους",
	"ποιουσ",
	"ποιων",
	"πολυ",
	"ποσες",
	"ποση",
	"ποσην",
	"ποσης",
	"ποσοι",
	"ποσος",
	"ποσους",
	"ποτε",
	"που",
	"πουθε",
	"πουθενα",
	"ποῦ",
	"πρεπει",
	"πριν",
	"προ",
	"προκειμενου",
	"προκειται",
	"προπερσι",
	"προς",
	"προσ",
	"προτου",
	"προχθες",
	"προχτες",
	"πρωτυτερα",
	"πρόσ",
	"πρὸ",
	"πρὸς",
	"πως",
	"πωσ",
	"σαν",
	"σας",
	"σε",
	"σεις",
	"σημερα",
	"σιγα",
	"σου",
	"στα",
	"στη",
	"στην",
	"στης",
	"στις",
	"στο",
	"στον",
	"στου",
	"στους",
	"στων",
	"συγχρονως",
	"συν",
	"συναμα",
	"συνεπως",
	"συνηθως",
	"συχνα",
	"συχνας",
	"συχνες",
	"συχνη",
	"συχνην",
	"συχνης",
	"συχνο",
	"συχνοι",
	"συχνον",
	"συχνος",
	"συχνου",
	"συχνους",
	"συχνων",
	"συχνως",
	"σχε∆ον",
	"σωστα",
	"σόσ",
	"σύ",
	"σύν",
	"σὸς",
	"σὺ",
	"σὺν",
	"τά",
	"τήν",
	"τί",
	"τίς",
	"τίσ",
	"τα",
	"ταυτα",
	"ταυτες",
	"ταυτη",
	"ταυτην",
	"ταυτης",
	"ταυτο,ταυτον",
	"ταυτος",
	"ταυτου",
	"ταυτων",
	"ταχα",
	"ταχατε",
	"ταῖς",
	"τα∆ε",
	"τε",
	"τελικα",
	"τελικως",
	"τες",
	"τετοια",
	"τετοιαν",
	"τετοιας",
	"τετοιες",
	"τετοιο",
	"τετοιοι",
	"τετοιον",
	"τετοιος",
	"τετοιου",
	"τετοιους",
	"τετοιων",
	"τη",
	"την",
	"της",
	"τησ",
	"τι",
	"τινα",
	"τιποτα",
	"τιποτε",
	"τις",
	"τισ",
	"το",
	"τοί",
	"τοι",
	"τοιοῦτος",
	"τοιοῦτοσ",
	"τον",
	"τος",
	"τοσα",
	"τοσες",
	"τοση",
	"τοσην",
	"τοσης",
	"τοσο",
	"τοσοι",
	"τοσον",
	"τοσος",
	"τοσου",
	"τοσους",
	"τοσων",
	"τοτε",
	"του",
	"τουλαχιστο",
	"τουλαχιστον",
	"τους",
	"τουτα",
	"τουτες",
	"τουτη",
	"τουτην",
	"τουτης",
	"τουτο",
	"τουτοι",
	"τουτοις",
	"τουτον",
	"τουτος",
	"τουτου",
	"τουτους",
	"τουτων",
	"τούσ",
	"τοὺς",
	"τοῖς",
	"τοῦ",
	"τυχον",
	"των",
	"τωρα",
	"τό",
	"τόν",
	"τότε",
	"τὰ",
	"τὰς",
	"τὴν",
	"τὸ",
	"τὸν",
	"τῆς",
	"τῆσ",
	"τῇ",
	"τῶν",
	"τῷ",
	"υπ",
	"υπερ",
	"υπο",
	"υποψη",
	"υποψιν",
	"υπό",
	"υστερα",
	"φετος",
	"χαμηλα",
	"χθες",
	"χτες",
	"χωρις",
	"χωριστα",
	"ψηλα",
	"ω",
	"ωραια",
	"ως",
	"ωσ",
	"ωσαν",
	"ωσοτου",
	"ωσπου",
	"ωστε",
	"ωστοσο",
	"ωχ",
	"ἀλλ'",
	"ἀλλά",
	"ἀλλὰ",
	"ἀλλ’",
	"ἀπ",
	"ἀπό",
	"ἀπὸ",
	"ἀφ",
	"ἂν",
	"ἃ",
	"ἄλλος",
	"ἄλλοσ",
	"ἄν",
	"ἄρα",
	"ἅμα",
	"ἐάν",
	"ἐγώ",
	"ἐγὼ",
	"ἐκ",
	"ἐμόσ",
	"ἐμὸς",
	"ἐν",
	"ἐξ",
	"ἐπί",
	"ἐπεὶ",
	"ἐπὶ",
	"ἐστι",
	"ἐφ",
	"ἐὰν",
	"ἑαυτοῦ",
	"ἔτι",
	"ἡ",
	"ἢ",
	"ἣ",
	"ἤ",
	"ἥ",
	"ἧς",
	"ἵνα",
	"ὁ",
	"ὃ",
	"ὃν",
	"ὃς",
	"ὅ",
	"ὅδε",
	"ὅθεν",
	"ὅπερ",
	"ὅς",
	"ὅσ",
	"ὅστις",
	"ὅστισ",
	"ὅτε",
	"ὅτι",
	"ὑμόσ",
	"ὑπ",
	"ὑπέρ",
	"ὑπό",
	"ὑπὲρ",
	"ὑπὸ",
	"ὡς",
	"ὡσ",
	"ὥς",
	"ὥστε",
	"ὦ",
	"ᾧ",
	"∆α",
	"∆ε",
	"∆εινα",
	"∆εν",
	"∆εξια",
	"∆ηθεν",
	"∆ηλα∆η",
	"∆ι",
	"∆ια",
	"∆ιαρκως",
	"∆ικα",
	"∆ικο",
	"∆ικοι",
	"∆ικος",
	"∆ικου",
	"∆ικους",
	"∆ιολου",
	"∆ιπλα",
	"∆ιχως",
];
